import { ControlConstants } from "../../control/constant/ControlConstants";
import { VerticalLayout } from "../../control/layout/VerticalLayout";
import { PanelProperties } from "../../control/properties/PanelProperties";
import { SpriteProperties } from "../../control/properties/SpriteProperties";
import { TextFieldProperties } from "../../control/properties/TextFieldProperties";
import { ToggleButtonProperties } from "../../control/properties/ToggleButtonProperties";
import { LanguageManager } from "../../manager/LanguageManager";
import { CommonLang } from "../lang/CommonLang";
import { CommonFontStyle } from "../style/CommonFontStyle";
import { CommonStyle } from "../style/CommonStyle";
import { AbstractViewProperties } from "./AbstractViewProperties";
/*
 * AbstractStakePanelProperties.ts
 */
export class AbstractStakePanelProperties extends AbstractViewProperties {
    constructor() {
        super();
        this.setDefaultValues();
    }
    equals(other) {
        return super.equals(other) &&
            this.toggleButtonProperties.equals(other.toggleButtonProperties) &&
            this.panelProperties.equals(other.panelProperties) &&
            this.valueButtonProperties.equals(other.valueButtonProperties) &&
            this.topProperties.equals(other.topProperties) &&
            this.bottomProperties.equals(other.bottomProperties) &&
            (this.openTweenDuration === other.openTweenDuration) &&
            (this.closeTweenDuration === other.closeTweenDuration) &&
            this.labelFieldProperties.equals(other.labelFieldProperties) &&
            (this.hideToggleButton === other.hideToggleButton) &&
            (this.closeOnSelection === other.closeOnSelection) &&
            (this.disableLabel === other.disableLabel);
    }
    setDefaultValues() {
        this.closeOnSelection = false;
        this.hideToggleButton = false;
        this.disableLabel = false;
        this.openTweenDuration = 0.5;
        this.closeTweenDuration = 0.25;
        this.labelRotation = 0;
        this.panelProperties = new PanelProperties();
        this.panelProperties.layout = new VerticalLayout(0);
        this.topProperties = new SpriteProperties(CommonStyle.STAKE_SELECTOR_TOP, CommonStyle.MODULE);
        this.bottomProperties = new SpriteProperties(CommonStyle.STAKE_SELECTOR_BOTTOM, CommonStyle.MODULE);
        this.valueButtonProperties = new ToggleButtonProperties(CommonStyle.STAKE_SELECTOR_VALUE_BUTTON, CommonStyle.MODULE);
        this.valueButtonProperties.textFieldProperties = new TextFieldProperties(CommonFontStyle.STAKE_SELECTOR_VALUE_BUTTON);
        this.toggleButtonProperties = new ToggleButtonProperties(CommonStyle.STAKE_SELECTOR_TOGGLE_BUTTON, CommonStyle.MODULE);
        this.toggleButtonProperties.accessibleOptions.accessibleHint = `${LanguageManager.getInstance().getLang(CommonLang.STAKE_BUTTON)}`;
    }
    createLabelFieldProperties() {
        this.labelFieldProperties = new TextFieldProperties(CommonFontStyle.STAKE_SELECTOR_LABEL, null, CommonLang.STAKE_BUTTON, ControlConstants.CENTER);
    }
}
export class AbstractHorizontalStakePanelProperties extends AbstractStakePanelProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.labelRotation = -90;
        this.createLabelFieldProperties();
    }
}
export class AbstractVerticalStakePanelProperties extends AbstractStakePanelProperties {
    constructor() {
        super();
        this.handlePanelType();
    }
    setDefaultValues() {
        super.setDefaultValues();
        this.hasSeparateValuePanel = false;
    }
    handlePanelType() {
        if (this.hasSeparateValuePanel) {
            this.createToggleButtonTextFieldProperties();
        }
        else {
            this.createAmountFieldProperties();
            this.createLabelFieldProperties();
        }
    }
    createAmountFieldProperties() {
        this.amountFieldProperties = new TextFieldProperties(CommonFontStyle.STAKE_SELECTOR_AMOUNT, null, null, ControlConstants.CENTER);
    }
    createToggleButtonTextFieldProperties() {
        this.toggleButtonProperties.textFieldProperties = new TextFieldProperties(CommonFontStyle.STAKE_SELECTOR_LABEL, null, CommonLang.STAKE_BUTTON);
    }
}
//# sourceMappingURL=AbstractStakePanelProperties.js.map